<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Users</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    class="dialog-close-button"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 p-4 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="industry">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Job Title</mat-label>
        <mat-select
          placeholder="Job Title"
          [(ngModel)]="filters.trade"
          id="trade"
          name="trade"
          matTooltip="Filter users by job title.">
          <mat-option value="">All Job Titles</mat-option>
          <mat-option *ngFor="let trade of filters.trades" [value]="trade.name">{{ trade.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon>clear_all</mat-icon> Clear Filter
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
